import { useRef } from 'react'
import { useTooltip } from '../../../../assets/frontend/js/hooks/tooltip'
import useReplaceImgixUrl from '../../../../assets/utils/useReplaceImgixUrl'
import { useConfigContext } from './ConfigContext'

function ServiceTeaser(props: {
  imageUrl?: string
  imageAlt?: string
  seriesDescription?: string
}) {
  const { imageUrl, imageAlt, seriesDescription } = props

  const seriesInfoRef = useRef<HTMLButtonElement>(null)

  useTooltip(
    seriesInfoRef,
    {
      title: seriesDescription,
      customClass: 'services-series-tooltip',
      placement: 'left'
    },
    [seriesDescription]
  )

  const { imgixSrcUrl, imgixTargetUrl } = useConfigContext()
  const replaceImgixUrl = useReplaceImgixUrl(imgixSrcUrl, imgixTargetUrl)
  const imgixUrl = imageUrl
    ? replaceImgixUrl(imageUrl, {
        ratio: '16:9',
        width: 1024
      })
    : ''

  return (
    <div className="services-teaser layers">
      {imgixUrl ? (
        <img className="image card-img-top" src={imgixUrl} alt={imageAlt} />
      ) : (
        <div className="image card-img-top-placeholder bg-dark-3" />
      )}
      {!!seriesDescription && (
        <i
          tabIndex={0}
          ref={seriesInfoRef}
          className="icon fa-info-circle ms-auto mt-auto mb-2 me-2"
        />
      )}
    </div>
  )
}

export default ServiceTeaser
